module.exports = __webpack_public_path__ + "media/old_images/close-39772f2d.png";